import ApiUrls from '@api/apiUrls';
import { fetchApi, FetchApiResponse } from '@api/fetchApi';
import { IApiUserClientSideTranslation } from '@api/services/user/clientSideTranslations/clientSideTranslation.apiService.interfaces';

export const apiUserClientSideTranslations = {
  getAll: async (language?: string): Promise<FetchApiResponse<IApiUserClientSideTranslation[]>> => {
    return await fetchApi.get<IApiUserClientSideTranslation[]>(ApiUrls.clientSideTranslation.getAll, {
      params: { language },
    });
  },
};
